if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.addToCartButton = document.querySelector('[data-add-to-cart]');
      this.addToCartButton.addEventListener('click', this.onSubmitHandler.bind(this));

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');

      if (!ProductForm.initialized) {
        let variantSelectors = document.querySelectorAll('.options__input');
        variantSelectors.forEach((variant) => {
          variant.addEventListener('change', (event) => {
            if (event.currentTarget.checked) {
              let deliveryDate = event.currentTarget.dataset.deliveryDate;
              let deliveryDateHex = event.currentTarget.dataset.deliveryDateHex;
              let deliveryDateElArr = event.currentTarget.closest('[data-variant-selector]').querySelectorAll('[data-delivery-date-target]');
              if (deliveryDate.length > 0) {
                deliveryDateElArr.forEach(function(deliveryDateEl){
                  deliveryDateEl.classList.remove('hidden');
                });
                if (deliveryDateHex.length > 0) {
                  deliveryDateElArr.forEach(function(deliveryDateEl){
                    deliveryDateEl.style.color = deliveryDateHex;
                  });
                }
                deliveryDateElArr.forEach(function(deliveryDateEl){
                  deliveryDateEl.innerHTML = deliveryDate;
                });
                event.currentTarget.closest('variant-radios').querySelector('[data-line-item-property]').value = deliveryDate;
              } else {
                deliveryDateElArr.forEach(function(deliveryDateEl){
                  deliveryDateEl.classList.add('hidden');
                });
                event.currentTarget.closest('variant-radios').querySelector('[data-line-item-property]').value = '';
              }
              ProductForm.checkATC();
            }
          });
        });

        ProductForm.checkATC();
        ProductForm.initialized = true;
      }
    }

    static checkATC() {
      let selectedVariants = document.querySelectorAll('.options__input:checked');
      if (selectedVariants.length > 0) {
        document.querySelector('[data-add-to-cart]').removeAttribute('disabled');
      } else {
        document.querySelector('[data-add-to-cart]').setAttribute('disabled', true);
      }
    }

    checkATC() {
      ProductForm.checkATC();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      let submitButton = '';

      if (evt.target.classList.contains('button')) {
        submitButton = evt.target;
      } else {
        submitButton = this.querySelector('[type="submit"]');
      }

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const sectionsToFetch  = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ...this.cartNotification.getSectionsToRender().map((section) => section.id)
      ];

      let items = [];
      let variantSelectors = document.querySelectorAll('[data-variant-selector]');
      variantSelectors.forEach(function(variantSelector){
        let quantity = variantSelector.querySelector('product-form input[name="quantity"]').value;
        let id = variantSelector.querySelector('product-form input[name="id"]').value;
        let property_key = variantSelector.querySelector('[data-line-item-property]').name;
        let property_value = variantSelector.querySelector('[data-line-item-property]').value;
        let properties = {};
        properties[property_key] = property_value;
        if (quantity > 0) {
          items.push({id: id, quantity: quantity, properties})
        }
      });

      // Reverse the items array before sending to cart
      items = items.reverse();

      let body = JSON.stringify({
        items: items,
        sections: sectionsToFetch,
        sections_url: window.location.pathname
      });

      // fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
      fetch(window.Shopify.routes.root + 'cart/add.js', {...fetchConfig(), ...{ body }})
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement);
            // this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
            window.alert(`${parsedState.description}`);
            return;
          }

          this.cartDrawer.renderContents(parsedState);
          this.cartDrawer.open();

        })
        .catch((e) => {
          console.log(e)
      })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
  }

  ProductForm.initialized = false;
  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}


